module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "all-categories mb-20"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t("profile.show.contactMe")))])]), _vm._v(" "), _c('form', [_c('form-error', {
    attrs: {
      "errors": _vm.errors,
      "attribute": 'body'
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message.body),
      expression: "message.body"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "8",
      "placeholder": _vm.$t('profile.show.contactTextarea')
    },
    domProps: {
      "value": (_vm.message.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.message, "body", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg button-wide-crowd",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sendMessage()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("profile.show.sendButton")))])], 1), _vm._v(" "), _c('alert', {
    attrs: {
      "success": _vm.alert.success
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b6e06d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/Contact.vue
// module id = 820
// module chunks = 1